import PropTypes from 'prop-types'
import { bowserFlags } from 'lib/bowser'
import { Col, Row } from 'react-bootstrap'
import { Input } from 'components/forms'

const NameFieldset = ({
  className,
  firstName,
  lastName,
  firstNameLabel,
  lastNameLabel,
  firstNamePlaceholder,
  lastNamePlaceholder,
}) => (
  <fieldset className={className}>
    <Row>
      <Col sm={6}>
        <Input
          {...firstName}
          placeholder={firstNamePlaceholder}
          label={firstNameLabel || 'First Name'}
          id="first_name"
          type="text"
          error={firstName.touched ? firstName.error : null}
          groupClassName={bowserFlags.mobile ? 'mbs' : ''}
        />
      </Col>
      <Col sm={6}>
        <Input
          {...lastName}
          placeholder={lastNamePlaceholder}
          label={lastNameLabel || 'Last Name'}
          id="last_name"
          type="text"
          error={lastName.touched ? lastName.error : null}
        />
      </Col>
    </Row>
  </fieldset>
)

NameFieldset.propTypes = {
  firstName: PropTypes.object.isRequired,
  lastName: PropTypes.object.isRequired,
  firstNamePlaceholder: PropTypes.string,
  lastNamePlaceholder: PropTypes.string,
}

export default NameFieldset
